import { ICrmListResponse } from '@common/interfaces/crm'
import { IMarketIntelligenceRow } from '@common/interfaces/marketIntelligence'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  // Every write is a SAVING type rather than a live-edit one: adding, removing
  // or repointing a tag can move a row out of the current filtered view (the
  // "needs tag review" quick filter especially), so the page refetches instead
  // of patching a row that may no longer belong in the list.
  items: createLoadingDataReducer<ICrmListResponse<IMarketIntelligenceRow>>(
    [actions.LIST_REQUEST],
    [
      actions.CREATE_REQUEST,
      actions.UPDATE_REQUEST,
      actions.DELETE_REQUEST,
      actions.ADD_TAGS_REQUEST,
      actions.RESOLVE_TAG_REQUEST,
      actions.DELETE_TAG_REQUEST,
    ],
  ),
})
